var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3079 15.0659L15.1238 14.6778C14.4793 13.6107 14.111 12.1555 14.0189 10.6033C13.8348 7.01388 15.1238 4.20049 17.1493 4.00647H17.2414C19.0828 4.00647 20.7401 6.52881 21.0163 10.0213C21.1083 11.5735 20.9242 13.0286 20.4638 14.1928L20.3718 14.5808H20.0035C19.359 14.4838 18.5304 14.4838 17.8859 14.5808C17.1493 14.5808 16.4127 14.7749 15.7683 14.9689L15.3079 15.0659Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68477 12.0583L8.86891 11.6703C9.5134 10.6031 9.88169 9.14797 9.97376 7.59577C10.1579 4.00631 8.86891 1.19293 6.84336 0.998901H6.7513C4.9099 0.998901 3.25263 3.52124 2.97641 7.01369C2.88434 8.56589 3.06849 10.0211 3.52884 11.1852L3.6209 11.5733H3.98919C4.63369 11.4762 5.46231 11.4762 6.1068 11.5733C6.84336 11.5733 7.57993 11.7673 8.22442 11.9613L8.68477 12.0583Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5181 22.9998C15.9951 22.9998 14.92 21.1566 15.0096 18.9782C15.0096 18.8106 15.0096 18.5593 15.0096 18.3917L15.0992 17.9728L20.0266 18.1404V18.5593C20.0266 18.7268 20.0266 18.9782 20.0266 19.1457C20.1161 21.3241 18.9515 22.9998 17.5181 22.9998Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46581 19.9927C7.98881 19.9927 9.06387 18.1495 8.97428 15.9711C8.97428 15.8035 8.97428 15.5522 8.97428 15.3846L8.88469 14.9657L3.95733 15.1333V15.5522C3.95733 15.7198 3.95733 15.9711 3.95733 16.1387C3.86774 18.317 5.03239 19.9927 6.46581 19.9927Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepsActive);
export default __webpack_public_path__ + "static/media/steps-active.2d159472dfd6bfe8eed8c0f0fcd4a08a.svg";
export { ForwardRef as ReactComponent };